import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-without-animation-home-four',
    templateUrl: './without-animation-home-four.component.html',
    styleUrls: ['./without-animation-home-four.component.scss'],
    standalone: false
})
export class WithoutAnimationHomeFourComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
